import { ViewportType, IntroScreenType } from 'game-ui-types'
import { create } from 'zustand'

export interface IntroScreenStore {
    isIntroScreenActive: boolean
    setIsIntroScreenActive: (isIntroScreenActive: boolean) => void
    viewportConfigs: {
        [key in IntroScreenType]: {
            [viewport in ViewportType]: {
                playButton: string
                leftArrowButton: string
                rightArrowButton: string
                paginationSection: string
                checkBoxSection: string
            }
        }
    }
}

export const useIntroScreenStore = create<IntroScreenStore>((set) => ({
    isIntroScreenActive: false,
    setIsIntroScreenActive: (isIntroScreenActive) => set({ isIntroScreenActive }),
    viewportConfigs: {
        [IntroScreenType.INTRO_SCREEN_CONFIG_A]: {
            [ViewportType.DESKTOP]: {
                playButton: 'absolute left-[1482px] top-[932px] mt-[10px]',
                paginationSection:
                    'absolute top-[918.78px] flex gap-[20px] left-[50%] -translate-x-1/2 -translate-y-1/2 items-center',
                checkBoxSection: 'absolute left-[160px] top-[976px] flex gap-[20px] items-center',
                rightArrowButton: 'absolute left-[1690px] top-[494px]',
                leftArrowButton: 'absolute left-[160px] top-[494px] -scale-x-100',
            },
            [ViewportType.MOBILE_PORTRAIT]: {
                playButton: 'absolute left-[266px] top-[1178px] mt-[10px]',
                paginationSection:
                    'absolute top-[972.5px] flex gap-[20px] left-[50%] -translate-x-1/2 -translate-y-1/2 items-center',
                checkBoxSection: 'absolute left-[258.5px] top-[1346px] flex gap-[20px] items-center',
                rightArrowButton: 'absolute left-[680px] top-[938px]',
                leftArrowButton: 'absolute left-[60px] top-[938px] -scale-x-100',
            },
            [ViewportType.MOBILE_LANDSCAPE]: {
                playButton: 'absolute left-[1062px] top-[696px] mt-[10px]',
                paginationSection:
                    'absolute top-[681.5px] flex gap-[20px] left-[50%] -translate-x-1/2 -translate-y-1/2 items-center',
                checkBoxSection: 'absolute left-[100px] top-[740px] flex gap-[20px] items-center',
                rightArrowButton: 'absolute left-[1270px] top-[361px]',
                leftArrowButton: 'absolute left-[100px] top-[361px] -scale-x-100',
            },
        },
        [IntroScreenType.INTRO_SCREEN_CONFIG_B]: {
            [ViewportType.DESKTOP]: {
                playButton: 'absolute left-[1528px] top-[832px] mt-[10px]',
                paginationSection:
                    'absolute top-[968.78px] flex gap-[20px] left-[31%] -translate-x-1/2 -translate-y-1/2 items-center',
                checkBoxSection: 'absolute left-[1520.5px] top-[957px] flex gap-[20px] items-center',
                rightArrowButton: 'absolute left-[1003.33px] top-[934px]',
                leftArrowButton: 'absolute left-[113.33px] top-[934px] -scale-x-100',
            },
            [ViewportType.MOBILE_PORTRAIT]: {
                playButton: 'absolute left-[266px] top-[1228px] mt-[10px]',
                paginationSection:
                    'absolute top-[1140.5px] flex gap-[20px] left-[50%] -translate-x-1/2 -translate-y-1/2 items-center',
                checkBoxSection: 'absolute left-[258.5px] top-[1356px] flex gap-[20px] items-center',
                rightArrowButton: 'absolute left-[680px] top-[1106px]',
                leftArrowButton: 'absolute left-[60px] top-[1106px] -scale-x-100',
            },
            [ViewportType.MOBILE_LANDSCAPE]: {
                playButton: 'absolute left-[1048px] top-[598px] mt-[10px]',
                paginationSection:
                    'absolute top-[734.5px] flex gap-[20px] left-[31%] -translate-x-1/2 -translate-y-1/2 items-center',
                checkBoxSection: 'absolute left-[1040.5px] top-[726px] flex gap-[20px] items-center',
                rightArrowButton: 'absolute left-[720px] top-[700px]',
                leftArrowButton: 'absolute left-[100px] top-[700px] -scale-x-100',
            },
        },
    },
}))
